import React from 'react';
import './App.css';
import HexMap from './HexMap';

function App() {
    return (
        <div className="App">
            <HexMap />
        </div>
    );
}

export default App;